export default __webpack_public_path__ + "static/media/img6.adb32cc3.png";